export enum SearchPref {
	ATTRIBUTE_HISTORY_ENABLED = 'metadata.history.enabled',
	KEYWORD_INCLUDE_CONTENTS_ENABLED = 'search.keywordIncludeContents',
	SIMPLE_ASSET_ID_SEARCH_ENABLED = 'image.simpleAssetIdSearchEnabled',
	SUGGESTIONS_ENABLED = 'search.searchSuggestHeader',
	AI_SEARCH_ENABLED = 'search.nls.enabled',
}

export enum SearchMethod {
	AI = 'ai',
	BASIC = 'basic',
	EXACT = 'exact',
}

export enum SearchContext {
	ADVANCED = 'advanced',
	ATTRIBUTE_HISTORY = 'attribute:history',
	IDENTIFIED_PEOPLE = 'identifiedPeople',
	KEYWORD = 'keyword',
	AI = 'ai',
	VIDEO_CLIP = 'video:clip',
	VISUAL_COLOR = 'visual:color',
	VISUAL_ASSET = 'visual:asset',
	CATEGORY = 'category',
	SAVED_SEARCH = 'search:saved',
	SAVED_CART = 'cart:saved',
}

export const SearchWithinContext = {
	[SearchContext.SAVED_CART]: SearchContext.SAVED_CART,
	[SearchContext.SAVED_SEARCH]: SearchContext.SAVED_SEARCH,
	[SearchContext.CATEGORY]: SearchContext.CATEGORY,
} as const;

export const SEARCH_WITHIN_ROUTE_NAME = <const>{
	[SearchContext.CATEGORY]: 'folder',
	[SearchContext.SAVED_SEARCH]: 'saved-search',
	[SearchContext.SAVED_CART]: 'collection',
};

export const SEARCH_WITHIN_ROUTE_CONTEXT_NAME = <const>{
	[SEARCH_WITHIN_ROUTE_NAME[SearchContext.CATEGORY]]: SearchContext.CATEGORY,
	[SEARCH_WITHIN_ROUTE_NAME[SearchContext.SAVED_SEARCH]]:
		SearchContext.SAVED_SEARCH,
	[SEARCH_WITHIN_ROUTE_NAME[SearchContext.SAVED_CART]]:
		SearchContext.SAVED_CART,
};

export const SEARCH_SUGGESTION_CONTEXTS = [
	SearchContext.KEYWORD,
	SearchContext.CATEGORY,
	SearchContext.SAVED_SEARCH,
	SearchContext.SAVED_CART,
	SearchContext.IDENTIFIED_PEOPLE,
];
